export type ProTrialVariant = 'control' | 'A';

const AB_REQUEST_TIMEOUT_MS = 3000;

export async function getProTrialVariant(
  experimentId: number
): Promise<ProTrialVariant> {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), AB_REQUEST_TIMEOUT_MS);

  try {
    const abResponse = await fetch(
      `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/${process.env.NEXT_PUBLIC_PREFIX_AB_TEST}/get-variant?experimentId=${experimentId}`,
      {
        method: 'GET',
        credentials: 'include',
        signal: controller.signal,
      }
    );
    const abData = await abResponse.json();
    const variantName = abData?.data?.variant?.name;
    if (!variantName) return 'control';
    return variantName === 'control' ? 'control' : 'A';
  } catch (_) {
    return 'control';
  } finally {
    clearTimeout(timeoutId);
  }
}
